import React, { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import { Link } from "react-router-dom";
import { AppContext } from "../context/ContenxtAPI";
import CardsSlider from "./CardsSlider";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CardsStaps = ({
  priceIndex,
  homeownerValue,
  onHomeownerChange,
  data,
  landdata,
}) => {
  const handleFindOutMore = (id) => {
    setSelectedPlan(id);
    console.log("wfewefwqefewid is :", id);
  };
  console.log(data, "hereisdata");

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const { setSelectedPlan } = useContext(AppContext);

  return (
    <>
      <div className="tabsBtn-Wecare">
        <Tabs
          value={homeownerValue}
          onChange={onHomeownerChange}
          aria-label="basic tabs example"
          className="main_tabs"
        >
          <Tab label="Homeowner" {...a11yProps(0)} className="tabeBtn" />
          <Tab label="LandLord" {...a11yProps(1)} className="tabeBtn" />
        </Tabs>
      </div>

      <div>
        <CustomTabPanel value={homeownerValue} index={0}>
          {windowWidth <= 760 ? (
            <CardsSlider
              priceIndex={priceIndex}
              tabIndexOfHomeownerOrLanlord={homeownerValue}
              homeOwnerData={data}
              landdata={landdata}
            />
          ) : (
            <div className="main_cards_staps_div">
              {data.map((item, i) => {
                const parts = item.title.split("+");
                return (
                  <div key={i} className="cards_staps">
                    <div>
                      <div className="card_titles">
                        <h1>
                          {parts[0]}
                          {parts.length > 1 && (
                            <span
                              style={{ color: "#7ff1ea", marginLeft: "3px" }}
                            >
                              +{parts[1]}
                            </span>
                          )}
                        </h1>
                        <p>{item.caption}</p>
                      </div>
                      <div className="cards_price">
                        <h1>{item.price}</h1> p/m
                      </div>
                      <div className="cards_actions mt">
                        <div className="cards_actions">
                          {item.working.map((item, i) => (
                            <div className="working" key={i}>
                              <CheckCircleOutlineRoundedIcon
                                style={{ color: "#604CD4" }}
                              />
                              {item}
                            </div>
                          ))}
                        </div>
                        <div className="cards_actions">
                          {item?.notworking?.map((item, i) => (
                            <div className="notwarking" key={i}>
                              <CancelOutlinedIcon
                                style={{ color: "#604CD4", opacity: "0.6" }}
                              />
                              <span className="spanundesr">{item}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <Link to={`/FindOutMore/${item.id}`}>
                      <Button
                        variant="contained"
                        className="card_btn"
                        onClick={() => handleFindOutMore(item.id)}
                      >
                        Find Out More
                      </Button>
                    </Link>
                  </div>
                );
              })}
            </div>
          )}
        </CustomTabPanel>
        <CustomTabPanel value={homeownerValue} index={1}>
          {windowWidth <= 760 ? (
            <CardsSlider
              priceIndex={priceIndex}
              tabIndexOfHomeownerOrLanlord={homeownerValue}
              homeOwnerData={data}
              landdata={landdata}
            />
          ) : (
            <div className="main_cards_staps_div">
              {landdata.map((item, i) => {
                const parts = item.title.split("+");
                return (
                  <div key={i} className="cards_staps">
                    <div>
                      <div className="card_titles">
                        <h1>
                          {parts[0]}
                          {parts.length > 1 && (
                            <span
                              style={{ color: "#7ff1ea", marginLeft: "3px" }}
                            >
                              +{parts[1]}
                            </span>
                          )}
                        </h1>
                        <p>{item.caption}</p>
                      </div>
                      <div className="cards_price">
                        <h1>{item.price}</h1> p/m
                      </div>
                      <div className="cards_actions mt">
                        <div className="cards_actions">
                          {item?.working?.map((item, i) => (
                            <div className="working" key={i}>
                              {" "}
                              <CheckCircleOutlineRoundedIcon
                                style={{ color: "#604CD4" }}
                              />
                              {item}
                            </div>
                          ))}
                        </div>
                        <div className="cards_actions">
                          {item?.notworking?.map((item, i) => (
                            <div className="notwarking" key={i}>
                              {" "}
                              <CancelOutlinedIcon
                                style={{ color: "#604CD4", opacity: "0.6" }}
                              />
                              <span className="spanundesr">{item}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <Link
                      to={`/FindOutMore/${item.id}`}
                      style={{ marginTop: "auto" }}
                    >
                      <Button
                        variant="contained"
                        className="card_btn"
                        onClick={() => handleFindOutMore(item.id)}
                      >
                        Find Out More
                      </Button>
                    </Link>
                  </div>
                );
              })}
            </div>
          )}
        </CustomTabPanel>
      </div>
    </>
  );
};

CardsStaps.propTypes = {
  priceIndex: PropTypes.number.isRequired,
  homeownerValue: PropTypes.number.isRequired,
  onHomeownerChange: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  landdata: PropTypes.array.isRequired,
};

export default CardsStaps;
